import { apiHub } from 'services';

export const useHubS3 = () => {
  const downloadUrl = async (url: string, fileName: string) => {
    var link = window.document.createElement('a');
    link.href = url;
    link.target = '_blank'
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFile = async (fileName: string) => {
    const { data: url } = await apiHub.post<string>(`/tmp-link`, { fileName });
    if (url) await downloadUrl(url, fileName);
  };

  return { downloadFile };
};
